import { Anchor, Stack, Text } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { queryKeys, RestApi } from "../shared/RestApi";
import { NavBarContainer } from "./NavBarContainer";

export function PrivacyPage() {
  const { t, i18n } = useTranslation();

  return (
    <NavBarContainer title={t("privacy.title")}>
      <Stack gap="md" align="center">
        <Anchor component={Link} to="/eula" size="lg">
          {t("privacy.eulaLink")}
        </Anchor>
        <Anchor
          href={`/privacypolicy/privacypolicy?lang=${encodeURIComponent(i18n.language)}`}
          size="lg"
        >
          {t("privacy.policyLink")}
        </Anchor>
        <Text size="sm" c="dimmed" ta="center">
          {t("privacy.note")}
        </Text>
      </Stack>
    </NavBarContainer>
  );
}

export function EulaPage() {
  const { t, i18n } = useTranslation();
  const { data: text, isPending, isError } = useQuery({
    queryKey: queryKeys.eula(i18n.language),
    queryFn: () => RestApi.getEulaText(i18n.language),
  });

  return (
    <NavBarContainer title={t("privacy.eulaLink")}>
      {isError && <Text c="red">{t("privacy.eulaLoadError")}</Text>}
      {isPending && <Text>{t("privacy.loading")}</Text>}
      {text && (
        <Text style={{ whiteSpace: "pre-wrap" }} component="pre">
          {text}
        </Text>
      )}
    </NavBarContainer>
  );
}
